<template>
  <div class="koc-block koc-purchase-summary-block">
    <header>
      <section class="koc-header-main koc-header-secondary">
        <h1 class="koc-header-title">
          Summary
        </h1>
      </section>
    </header>

    <main class="koc-content-main">
      <div
        v-for="(item, index) in preview.next.line_items"
        :key="index"
        class="koc-product koc-row"
        :class="{ 'koc-total': item.kind === 'charge' }"
      >
        <p class="koc-item">
          {{ item.name }}
        </p>
        <p class="koc-price">
          {{ formatPrice(item.amount_in_cents) }}
        </p>
      </div>
    </main>
  </div>
</template>

<script src="./summary.js"></script>
<style lang="scss" scoped src="./summary.scss"></style>
